export enum CourseModality {
  faceToFace = 1,
  blended = 2,
  online = 3,
  eLearning = 4,
  virtual = 5,
  selfInstruction = 6,
}
export const getTranslationKey = (modality: CourseModality) => {
  const modalities = {
    [CourseModality.faceToFace]: 'faceToFace',
    [CourseModality.online]: 'online',
    [CourseModality.eLearning]: 'eLearning',
    [CourseModality.virtual]: 'virtual',
    [CourseModality.selfInstruction]: 'selfInstruction',
  }
  return modalities[modality] || 'blended'
}
